// extracted by mini-css-extract-plugin
export default {"overlay":"iB-z","bodyOpen":"jB-z","content":"kB-z","header":"lB-z","close":"mB-z","closeNoHeading":"nB-z"};